<template>
  <div class="flex-grow-1 atm-rounded module--card w-25">
    <picture class="module--card--logo">
      <img class="module--card--logo__img" :src="icon" alt="logo" />
    </picture>
    <div class="module--card--content" @click="goToModule">
      <h5 class="font-weight-bolder w-100">{{ name }}</h5>
      <p class="w-100">{{ countLessons }} lessons</p>
      <b-progress class="module--card--content__progress rounded-pill w-100 mt-auto" :max="topics">
        <b-progress-bar
          :value="topicsViewed"
          :label="`${((topicsViewed / topics) * 100).toFixed(0)}%`"
        ></b-progress-bar>
      </b-progress>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    skillId: [String, Number],
    icon: {
      type: String,
      default: '',
    },
    topics: {
      type: Number,
      default: 0,
    },
    topicsViewed: {
      type: Number,
      default: 0,
    },
    name: {
      type: String,
      default: '',
    },
    countLessons: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {

    };
  },
  methods: {
    goToModule() {
      localStorage.setItem('lessonIcon', this.icon);
      this.$router.push({ name: 'lessons', params: { id: this.skillId } });
    },
  },
};
</script>
<style lang="scss" scoped>
.module--card {
  min-width: 250px;
  display: flex;
  padding: 1rem;
  background: #ffff;
  box-shadow: var(--atm-shadow);
  cursor: pointer;

  &--logo {
    width: 75px;
    margin-right: 1rem;

    &__img {
      object-fit: contain;
      width: 100%;
      height: 100%;
    }
  }

  &--content {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }
}
</style>
